<!--
    Component Collection Detail
    A detailed view of a Collection
    @author Leander Eyer <leander.eyer@elead.ch>
-->

<template>

	<div class='container'>
		<div id="content" class='content' v-if="cursor < 0">
			
			<div class="bar darkText largeText">
				<div class="gridLabel bg-collection">{{ model.getDictionary('nav_collection') }}</div>

				<div class="gridTriple bg-collection-light">
					{{ collection.getName() }}
				</div>
				<div class="link collection-close" @click="$parent.select()">x</div>
			</div>	

			<div v-if="collection.getIsExtern()" class="collection-extern">
				<div class="collection-desc" v-html=" descriptionWithNewLines "></div>
				<div class="collection-link"><a v-bind:href="linkExtern" target='_BLANK'>{{ linkExtern }}</a></div>
			</div>

			<div class="work-grid" @touchstart="touchStartScroll($event)" @touchend="touchEndScroll($event)" @wheel.prevent="scroll($event.deltaY > 0? 1 : -1)">
				<div
					class="work-image zoomable link"
					v-for="(work, index) in list.slice(slice, slice + sliceSize)"
					:key="work.getID()"
				>
					<img
						v-if="work.getImages().isImage()"
						:src="work.getImages().getImageURL(previewImageQuality)"
						:title="work.getToolTip()"
						@click="select(index + slice)"
					/>
					<div v-else 
						v-html="work.getImages().getMultiMediaHTML(0, 'preview')"
						:title="work.getArtistLabel() + ' - ' + work.getTitle() + ' (' + work.getYear() + ')'"
						@click="select(index + slice)" ></div>

				</div>
				<div
					class="work-grid-up arrow"
					v-if="slice > 0"
					@click.left="scroll(-1)"
					@mousedown.left="autoscroll('start', -1)"
					@mouseup.left="autoscroll('stop')"
				>&#x25B2;</div>
				<div
					class="work-grid-down arrow"
					v-if="slice < maxSlice"
					@click.left="scroll(1)"
					@mousedown.left="autoscroll('start', 1)"
					@mouseup.left="autoscroll('stop')"
				>&#x25BC;</div>
			</div>
		</div>

		<work-detail v-if="cursor >= 0" :list="list" :index="cursor"></work-detail>

	</div>
</template>

<script>

	import Vue from "vue";
	import { model } from "./../model/Model.js";
	import { ListWithCursor } from "./../mixin/ListWithCursor.js";
	import { Scrollable } from "./../mixin/Scrollable.js";
	import WorkDetail from "./WorkDetail.vue";
	import { GRID_COLUMNS, GRID_CELLS } from '../model/config';

	export default {

		mixins: [ListWithCursor, Scrollable],
		components: { WorkDetail },
		props: ["collection"],

		data: function() { 
			return {
				// expose model for translations
				model: model,
				// source of the preview images
				previewImageQuality: 'small',
				// number of cells visible at once
				sliceSize: GRID_CELLS
			};
		},

		computed: {
			// Prepare the Description for display by adding newlines
			descriptionWithNewLines: function() {
				return this.collection.getDescription().replace(/\n/g, "<br>");
			},
			linkExtern: function() {
				let link = this.collection.getLinkExtern();
				if (link.substring(0, 4) != "http") {
					link = "https://" + link;
				}
				return link;
			}
		},

		created: function() {
			this.list = this.collection.getWorks();
			this.sliceSize = Vue.prototype.$device == 'large'? GRID_CELLS : 4;
			this.scrollBy = Vue.prototype.$device == 'large'? GRID_COLUMNS : 2;
			this.maxSlice = Math.max(0, this.list.length - this.sliceSize);
			this.previewImageQuality = Vue.prototype.$previewImageQuality;
		}

	};
</script>

<style>

div.collection-link {
	margin-top: 2rem;
}

@media (min-width: 1000px) {

	div.collection-close {
		display: inline;
		position: absolute;
		right: 3rem;
		top: 0rem;
	}

}

@media (max-width: 1000px) {

	div.collection-close {
		position: absolute;
		top: 2.5rem;
		right: 0.5rem;
		font-size: 2rem;
	}

}

</style>